export enum SequenceStatus {
  NotStarted = 'not_started',
  Started = 'started',
  ProcessingSubmitted = 'processing_submitted',
  Submitted = 'submitted',
  ProcessingCompleted = 'processing_completed',
  Completed = 'completed',
  Skipped = 'skipped',
  Archived = 'archived',
}

export enum InteractionStatus {
  Empty = 'empty',
  Draft = 'draft',
  DraftRetry = 'draft_retry',
  Processing = 'processing',
  Submitted = 'submitted',
  WaitingForSelfScore = 'waiting_for_selfscore',
  ProcessingSelfScore = 'processing_selfscore',
  Checked = 'checked',
  Completed = 'completed',
  Disabled = 'disabled', // Used when sequence are not yet started
  Archived = 'archived',
}

const interactionStatusValues = Object.values(InteractionStatus);

export const statusThreshold = (
  status: InteractionStatus | undefined,
  threshold: InteractionStatus,
  reverse = false,
) => {
  if (!status) return false;
  const index = interactionStatusValues.indexOf(threshold);
  const statusIndex = interactionStatusValues.indexOf(status);
  if (reverse) {
    return statusIndex <= index;
  }
  return statusIndex >= index;
};

export const statusGreaterThan = (
  status: InteractionStatus | undefined,
  threshold: InteractionStatus,
) => statusThreshold(status, threshold);

export const statusLessThan = (
  status: InteractionStatus | undefined,
  threshold: InteractionStatus,
) => statusThreshold(status, threshold, true);
